import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRulerVertical,
  faWeight,
  faTemperatureHalf,
  faHeartbeat,
  faTachometerAlt,
  faDroplet,
  faLungs,
  faFaceFrown,
} from "@fortawesome/free-solid-svg-icons";
import ChevronDown from "../../../../assets/patientcharts/Chevron_Down.png";
import moment from "moment";
import blinkscribeapi from "../../../../api/blinkscribeapi";
import { Audiocards } from "../priorvisits/audiocards";
import { eventBus } from "../../../../utils/eventBus";
import dayjs from "dayjs";
import { Backdrop, CircularProgress } from "@mui/material";
import Editscreen from "../../../../blinkscribe/archeivescreens/editscreen";
import { ShowMoreICon } from "../tabsvgs";

export const DropDownFrame = ({
  previousVitals,
  fetchpreviousdx,
  isLoadingVitals,
  dxvitals,
  fetchpreviousvitals,
  data: dataId,
}) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    vitals: "",
    dx: "",
  });
  const [showAllVitals, setShowAllVitals] = useState(false);
  const [blinkscribeRecord, setBlinkscribeRecord] = useState(null);
  const [isLoadingNotes, setIsLoadingNotes] = useState(false);
  const [audioSrc, setAudioSrc] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [showloader, setShowLoader] = useState(false);
  const [editcard, setEditCard] = useState({});
  const [isEditscreen, setIsEditScreen] = useState(false);

  const wrapperRef = useRef(null);

  const handleToggle = (dropdown) => {
    if (dropdown === "vitals") {
      fetchpreviousvitals();
    }
    if (dropdown === "dx") {
      fetchpreviousdx();
    }
    setOpenDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  useEffect(() => {
    fetchpreviousvitals();
    if (dataId?.patientid) {
      fetchBlinkscribeRecord();
    }
  }, [dataId?.patientid]);

  const fetchBlinkscribeRecord = async () => {
    try {
      setIsLoadingNotes(true);
      const payload = {
        filter_array: {
          date_filter: {
            start_date: dayjs().subtract(30, "days").format("YYYY-MM-DD"),
            end_date: dayjs().format("YYYY-MM-DD"),
          },
        },
      };
      const response = await blinkscribeapi.post(
        `/v1/patient/${dataId.patientid}/recording/details`,
        payload,
      );
      if (response.status === 200 && response?.data?.length > 0) {
        // Get the most recent record
        setBlinkscribeRecord(response.data[0]);
      } else {
        setBlinkscribeRecord(null);
      }
    } catch (error) {
      console.log(error);
      setBlinkscribeRecord(null);
    } finally {
      setIsLoadingNotes(false);
    }
  };

  const handleViewAll = () => {
    // Emit event to navigate to Prior Visit tab with BlinkScribe selected
    eventBus.emit("navigateToPriorVisit", { tab: 5, internalTab: 1 });
  };

  const handleplay = async (audio_link) => {
    try {
      setShowLoader(true);
      const response = await blinkscribeapi.get(`/v1/audio/${audio_link}`, {
        responseType: "blob",
      });
      const fileBlob = response;
      const audioURL = URL.createObjectURL(fileBlob);
      setAudioSrc(audioURL);
      if (fileBlob && fileBlob.size == 0) {
        setAudioSrc("");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoader(false);
    }
  };

  const handlepdf = async (value, card) => {
    setShowLoader(true);
    if (card.transcriptionstatus == "Processing") {
      return;
    }
    try {
      const uniqueParam = new Date().getTime();
      const response = await blinkscribeapi.get(
        `/v1/documents/PDF/${value}?_=${uniqueParam}`,
        {
          responseType: "blob",
        },
      );
      const pdfBlob = new Blob([response], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error fetching the PDF:", error);
    } finally {
      setShowLoader(false);
    }
  };

  const handleImg = async (value, card) => {
    setShowLoader(true);
    if (card.transcriptionstatus === "Processing") {
      return;
    }
    try {
      const uniqueParam = new Date().getTime();
      const response = await blinkscribeapi.get(
        `/v1/documents/PDF/${value}?_=${uniqueParam}`,
        {
          responseType: "blob",
        },
      );
      const pdfBlob = response;
      const pdfArrayBuffer = await pdfBlob.arrayBuffer();
      const pdf = await window.pdfjsLib.getDocument({ data: pdfArrayBuffer })
        .promise;
      const scale = 2;
      const pageCanvases = [];
      let totalHeight = 0;
      let maxWidth = 0;
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: context, viewport }).promise;
        pageCanvases.push(canvas);
        totalHeight += canvas.height;
        maxWidth = Math.max(maxWidth, canvas.width);
      }
      const combinedCanvas = document.createElement("canvas");
      combinedCanvas.width = maxWidth;
      combinedCanvas.height = totalHeight;
      const combinedCtx = combinedCanvas.getContext("2d");
      let yOffset = 0;
      for (const canvas of pageCanvases) {
        combinedCtx.drawImage(canvas, 0, yOffset);
        yOffset += canvas.height;
      }
      combinedCanvas.toBlob((blob) => {
        const imageUrl = URL.createObjectURL(blob);
        window.open(imageUrl, "_blank");
      }, "image/png");
    } catch (error) {
      console.error("Error fetching the file:", error);
    } finally {
      setShowLoader(false);
    }
  };
const cardWidth =
  "basis-[calc(16.666%-16px)] max-w-[calc(16.666%-16px)]";

  const handleSelect = (dropdown, option) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [dropdown]: option,
    }));
    setOpenDropdown(null);
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
const calculateBMI = (w, unit, ft, inch) => {
  const weightNum = parseFloat(w);
  const heightInches =
    parseFloat(ft || 0) * 12 + parseFloat(inch || 0);

  if (!weightNum || !heightInches) return "";

  const meters = heightInches * 0.0254;

  const kg =
    unit === "lbs"
      ? weightNum * 0.45359237
      : unit === "stone"
      ? weightNum * 6.35029
      : weightNum;

  return (kg / (meters * meters)).toFixed(1);
};
  // Format vitals into card structure
  const formatVitalsToCards = (vitals) => {
    const cards = [];

    const bmiValue = calculateBMI(
  vitals?.weight,
  vitals?.weight_cel,
  vitals?.height_ft,
  vitals?.height_in
);
    // Height
    if (vitals.height_ft || vitals.height_in) {
      const heightValue = `${vitals.height_ft || ""}'${vitals.height_in || ""}" `;
      cards.push({
        title: "HEIGHT",
        value: heightValue,
        subValue: ` `,
        context: vitals.height_pos || "",
        priority: 3,
      });
    }

    // Weight
    if (vitals.weight) {
      const weightValue = `${vitals.weight}`;
      cards.push({
        title: "WEIGHT",
        value: weightValue,
        subValue: `${vitals.weight_cel || ""}`,
        context: vitals.weight_drop || "",
        priority: 4,
      });
    }

    // Temperature
    if (vitals.temp) {
      const tempValue = `${vitals.temp} `;
      cards.push({
        title: "TEMP",
        value: tempValue,
        subValue: `${vitals.temp_cel || "°F"}`,
        context: vitals.temp_drop || "",
        priority: 5,
      });
    }

    // Pulse
    if (vitals.plus_bpm) {
      const pulseValue = `${vitals.plus_bpm}`;
      cards.push({
        title: "PULSE",
        value: pulseValue,
        subValue: "bpm",
        context: vitals.plus_drop || "",
        priority: 2,
      });
    }

    // Blood Pressure
    if (vitals.bp_mm && vitals.bp_hgg) {
      const bpValue = `${vitals.bp_mm}/${vitals.bp_hgg}`;
      cards.push({
        title: "BP",
        value: bpValue,
        subValue: "mmHg",
        context: vitals.bp_pos || "",
        priority: 1,
      });
    }

    // Oxygen Saturation
    if (vitals.o2_1 || vitals.o2_2) {
      const o2Value = `${vitals.o2_1 || vitals.o2_2} `;
      cards.push({
        title: "O₂ SAT",
        value: o2Value,
        subValue: `%`,
        context: vitals.o2_drop || "",
        priority: 6,
      });
    }

    // Pain
    if (vitals.pain_level) {
      cards.push({
        title: "PAIN",
        value: `${vitals.pain_level}`,
        subValue: "/10",
        context: "",
        priority: 7,
      });
    }

    // BMI
    if (bmiValue && !isNaN(bmiValue)) {
      cards.push({
        title: "BMI",
        value: bmiValue,
        context: "",
        priority: 8,
      });
    }

    // Respiration
    if (vitals.respiratory) {
      const respValue = `${vitals.respiratory}`;
      cards.push({
        title: "RESP",
        value: respValue,
        subValue: "bpm",
        context: vitals.respiratory_drop || "",
        priority: 9,
      });
    }

    // Glucose
    if (vitals.bg) {
      const glucoseValue = `${vitals.bg} `;
      cards.push({
        title: "GLUCOSE",
        value: glucoseValue,
        subValue: `${vitals.bg_cel || "mg/dl"}`,
        context: vitals.bg_drop || "",
        priority: 10,
      });
    }

    // Sort by priority to ensure consistent order
    return cards.sort((a, b) => a.priority - b.priority);
  };

  // Format vitals with icons (keeping for backward compatibility if needed)
  const formatVitals = (vitals) => {
    const items = [];
    if (vitals.height_ft || vitals.height_in) {
      items.push({
        label: `Height  ${vitals.height_ft || ""}ft ${vitals.height_in || ""}in ${vitals.height_pos ? `(${vitals.height_pos})` : ""}`,
        icon: faRulerVertical,
      });
    }
    if (vitals.weight) {
      items.push({
        label: `Weight  ${vitals.weight} ${vitals.weight_cel || ""} ${vitals.weight_drop ? `(${vitals.weight_drop})` : ""}`,
        icon: faWeight,
      });
    }
    if (vitals.temp) {
      items.push({
        label: `Temp  ${vitals.temp}°${vitals.temp_cel || ""} ${vitals.temp_drop ? `(${vitals.temp_drop})` : ""}`,
        icon: faTemperatureHalf,
      });
    }
    if (vitals.plus_bpm) {
      items.push({
        label: `Pulse  ${vitals.plus_bpm} bpm ${vitals.plus_drop ? `(${vitals.plus_drop})` : ""}`,
        icon: faHeartbeat,
      });
    }
    if (vitals.bp_mm && vitals.bp_hgg) {
      items.push({
        label: `BP  ${vitals.bp_mm}/${vitals.bp_hgg} mmHg ${vitals.bp_pos ? `(${vitals.bp_pos})` : ""} ${vitals.bp_drop ? `(${vitals.bp_drop})` : ""}`,
        icon: faTachometerAlt,
      });
    }
    if (vitals.bg) {
      items.push({
        label: `Glucose  ${vitals.bg} ${vitals.bg_cel || ""} ${vitals.bg_drop ? `(${vitals.bg_drop})` : ""}`,
        icon: faDroplet,
      });
    }
    if (vitals.o2_1 || vitals.o2_2) {
      items.push({
        label: `O₂: ${vitals.o2_1 || vitals.o2_2}% ${vitals.o2_drop ? `(${vitals.o2_drop})` : ""}`,
        icon: faLungs,
      });
    }
    if (vitals.pain_level) {
      items.push({ label: `Pain  ${vitals.pain_level}`, icon: faFaceFrown });
    }
    return items;
  };

  return (
    <div>
      <div
        ref={wrapperRef}
        className="flex w-full justify-between gap-[32px] px-4 pl-2"
      >
        {/* Vitals Dropdown */}
        {/* <div className="relative w-1/2 h-9 bg-white rounded-[38px] border border-solid border-[#eeeeee] flex items-center justify-between px-4"> */}
        {/* <div className="text-[#1d2951] text-sm font-normal flex-grow truncate text-start">
            {"Vitals"}
          </div>
          <div
            className={`absolute right-1 top-1/2 transform ${
              openDropdown === "vitals"
                ? "-translate-y-1/2 rotate-180"
                : "-translate-y-1/2"
            } bg-[#f6f6f6] rounded-full w-7 h-7 flex items-center justify-center cursor-pointer transition-transform`}
            onClick={() => handleToggle("vitals")}
          >
            <img src={ChevronDown} alt="Chevron Down" className="w-4 h-4" />
          </div> */}

        {/* {openDropdown === 'vitals' && (
          <div className="absolute z-10 left-0 top-10 bg-white border border-solid border-[#eeeeee] rounded-lg shadow-lg w-[300px] max-h-[300px] overflow-y-auto p-2">
            {isLoadingVitals ? (
              <div className="p-2 text-xs text-gray-400 text-start">Loading vitals...</div>
            ) : previousVitals?.length > 0 ? (
              previousVitals.map((vital, idx) => {
                const list = formatVitals(vital);
                return (
                  <div
                    key={idx}
                    className="p-3 mb-2 rounded-lg border border-gray-200 hover:bg-[#f9f9f9] cursor-pointer transition"
                    onClick={() => handleSelect('vitals', `Vitals (${vital.created_at})`)}
                  >
                    <div className="text-xs text-gray-500 mb-2 font-semibold">
                      {vital.created_at ? new Date(vital.created_at).toLocaleString() : 'Unknown date'}
                    </div>
                    <ul className="text-xs text-[#1d2951] space-y-1 text-start">
                      {list.map((item, i) => (
                        <li key={i} className="flex items-center gap-2">
                          <FontAwesomeIcon icon={item.icon} className="text-gray-500 w-3.5" />
                          <span>{item.label}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })
            ) : (
              <div className="p-2 text-xs text-gray-400 text-start">No vitals available</div>
            )}
          </div>
        )} */}
      </div>

      {/* Diagnosis Dropdown */}
      {/* <div className="relative  h-9 w-1/2 bg-white rounded-[38px] border border-solid border-[#eeeeee] flex items-center px-4">
          <div className="text-[#1d2951] text-sm font-normal flex-grow truncate text-start">
            {selectedOptions.dx || "DX"}
          </div>
          <div
            className={`absolute right-1 top-1/2 transform ${openDropdown === "dx" ? "-translate-y-1/2 rotate-180" : "-translate-y-1/2"} bg-[#f6f6f6] rounded-full w-7 h-7 flex items-center justify-center cursor-pointer transition-transform`}
            onClick={() => handleToggle("dx")}
          >
            <img src={ChevronDown} alt="Chevron Down" className="w-4 h-4" />
          </div>

          {openDropdown === "dx" && (
            <div className="absolute z-10 left-0 top-10 bg-white border border-solid border-[#eeeeee] rounded-lg shadow-lg w-full custom-scrollbar overflow-y-auto ">
              {isLoadingVitals ? (
                <div className="p-2 text-xs text-gray-400 text-start">
                  Loading diagnosis...
                </div>
              ) : dxvitals?.diagnosis?.length > 0 ? (
                dxvitals.diagnosis.map((option, index) => (
                  <div
                    key={index}
                    className="py-2 mb-2 px-2 w-full rounded-lg border-b border-gray-200 hover:bg-[#f9f9f9] cursor-pointer transition text-xs text-[#1d2951] text-start"
                    onClick={() => handleSelect("dx", option)}
                  >
                    {option}
                  </div>
                ))
              ) : (
                <div className="p-2 text-xs text-gray-400 text-start">
                  No diagnosis available
                </div>
              )}
            </div>
          )}
        </div> */}
      {/* </div> */}
      {
        <div className="">
          {isLoadingVitals ? (
            <div className="p-2 text-xs text-gray-400 text-start">
              Getting vitals...
            </div>
          ) : previousVitals?.length > 0 ? (
            previousVitals.map((vital, idx) => {
              const cards = formatVitalsToCards(vital);
              // const initialCards = cards.slice(0, 4);
              // const remainingCards = cards.slice(4);
              // const displayCards = showAllVitals ? cards : initialCards;
const shouldShowMore = cards.length > 7;
const initialCards = shouldShowMore ? cards.slice(0, 5) : cards;

const displayCards = showAllVitals ? cards : initialCards;

              return (
                <div key={idx}>
                  <div className="flex justify-between items-center pr-8 mb-4">
                    <div className="text-[22px] font-bold font-inter text-[#1D2951] leading-[33px]">
                      Vitals
                    </div>
                    <div className="text-[#6A7282] text-[14px] font-inter leading-[20px]">
                      Last updated:{" "}
                      {moment(vital.created_at).format("MM/DD/YYYY")}
                    </div>
                  </div>

                  {/* Vitals Cards Grid */}
                  <div className="flex flex-wrap gap-4 mb-4">
                    {displayCards.map((card, i) => (
                      <div
                        key={i}
                        className={`    ${cardWidth} bg-[#FFF] border-[#F3F4F6] border-[1px] shadow-md rounded-[14px] px-5 pt-[14px] pb-[9px] flex flex-col items-start`}
                        // style={{ maxWidth: "calc(20% - 16px)" }}
                      >
                        <p className="text-[#99A1AF] text-[11px] font-inter font-bold leading-4 mb-1">
                          {card.title}
                        </p>
                        <div className="flex items-center mb-2">
                          <p className="text-[#1D2951] text-xl font-bold font-inter leading-7">
                            {card.value}
                          </p>
                          {card?.subValue && (
                            <p className="text-[#6A7282] text-[13px] font-medium font-inter leading-4">
                              {card.subValue}
                            </p>
                          )}
                        </div>
                        {card.context && (
                          <div className="flex justify-end items-end">
                            <span className="inline-block bg-[#F9FAFB] text-[#99A1AF] font-medium text-[10px] px-[6px] py-1 rounded-md">
                              {card.context}
                            </span>
                          </div>
                        )}
                      </div>
                    ))}

                    {/* Show More Card - only show if not all cards are displayed */}
               {!showAllVitals && shouldShowMore && (

                      <div
                        onClick={() => setShowAllVitals(true)}
                     className={`   ${cardWidth} bg-[#F9FAFB] border border-[#D1D5DC] rounded-[14px]
           p-4 flex flex-col items-center justify-center min-h-[120px]
           cursor-pointer transition-colors
        `}

                      >
                        <div className="w-[34px] h-[34px] rounded-full bg-[#FFFFFF] border-[1px] border-[#E5E7EB] flex items-center justify-center mb-2">
                          {ShowMoreICon}
                        </div>
                        <div className="text-[#9CA3AF] text-xs font-normal uppercase">
                          SHOW MORE
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="p-2 text-xs text-gray-400 text-start">
              No vitals available
            </div>
          )}
        </div>
      }

      {/* Notes Section */}
      {blinkscribeRecord && (
        <div className="mt-6">
          <div className="flex justify-between items-center mb-4">
            <div className="text-[22px] font-bold font-inter text-[#1D2951] leading-[33px]">
              Notes
            </div>
            <div
              onClick={handleViewAll}
              className="flex items-center gap-2 cursor-pointer text-[#E17954] text-[14px] font-inter font-medium hover:underline"
            >
              <span>View All</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12L10 8L6 4"
                  stroke="#E17954"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <div className="mb-4">
            <Audiocards
              card={blinkscribeRecord}
              handlepdf={handlepdf}
              setIsEditScreen={setIsEditScreen}
              handleplay={handleplay}
              audioSrc={audioSrc}
              selectedCard={selectedCard}
              setSelectedCard={setSelectedCard}
              setEditCard={setEditCard}
              setAudioSrc={setAudioSrc}
              fetchimg={handleImg}
              data={dataId}
              searchDate={dayjs().format("YYYY-MM-DD")}
            />
          </div>
        </div>
      )}

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={showloader || isLoadingNotes}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {isEditscreen && (
        <Editscreen
          selectedRecord={editcard}
          setIsEditScreen={setIsEditScreen}
        />
      )}
    </div>
  );
};
